import { combineReducers } from 'redux'
import alerts from "./alerts"
import user from "./auth"
import table_status from "./table_state"

export default combineReducers({
    alerts,
    user,
    table_status
})